import React, { Component } from "react";
import styled from "styled-components";
import { LabelDecimal, LabelDollarFormatted, LabelString, TableDefault } from '@loanbossinc/component-library';

const StyledLenderCell = styled.div`
  && {
    display: flex;
    flex-direction: column;
    border: none;

    span {
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      display: -webkit-box;
    }

    .loan-type {
      font-family: Work Sans;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      color: #5F6368;
    }
  }
`;

const StyledLabelString = styled(LabelString)`
  && {
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    color: #000000;
  }
`;

const StyledTable = styled(TableDefault)`
  && {
    border-bottom: 1px solid #DADCE0;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    box-shadow: none;
    font-size: 14px;
      
    table thead tr th {
      font-family: Work Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 14px;
      color: #5F6368;
    }
  }
`;

export class QuoteTable extends Component {
  columns = [
    {
      id: 'lender'
      , label: 'LENDER'
      , path: 'lender'
      , alignHeader: 'center'
      , Cell: (value) => (
        <StyledLenderCell>
          <StyledLabelString value={value.name ? value.name.trim() : ""} />
          {value.loanType && <LabelString className="loan-type" value={value.loanType ? value.loanType.trim() : ""} />}
        </StyledLenderCell>
      )
    }
    , {
      id: 'amount'
      , label: 'AMOUNT'
      , path: 'amount'
      , alignHeader: 'center'
      , Cell: (value) => <LabelDollarFormatted value={value} decimals={0} />
    }
    , {
      id: 'loanTermMonths'
      , label: 'TERM'
      , path: 'loanTermMonths'
      , alignHeader: 'center'
      , Cell: (value) => <LabelDecimal value={value} decimals={0} />
    }
    , {
      id: 'loanPricing'
      , label: 'PRICING'
      , path: 'loanPricing'
      , alignHeader: 'center'
      , Cell: (value) => <LabelString style={{fontFamily: 'Space Mono'}} value={value} />
    }
  ];

  mapData = () => {
    const { data } = this.props;

    return data.map(item => ({
      ...item
      , lender: {
        name: item.loanProvider && item.loanProvider[0] && item.loanProvider[0].name
        , loanType: item.loanType && item.loanType.name
      }
    }));
  }

  render() {
    const { data, dealId } = this.props;
    if (!data || !data.length) return null;

    return (
      <StyledTable
        columns={this.columns}
        onRowClick={item => this.props.history.push(`/quotes/${dealId}/${item.id}`)}
        items={this.mapData()}
      />
    );
  }
}
